var version = {
    "name":      "dativery",
    "buildDateCode": "20261104-161728",
    "buildDate": "Wed Nov 04 2026 16:17:28 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261104-161728",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;